module.exports = __webpack_public_path__ + "img/img_3.047ea9ef.jpg";